// import React, { useState } from 'react'

export default function About(props) {

    // const [myStyle, setMyStyle] = useState(
    // {
    //     color: 'black',
    //     backgroundColor: 'white',
    // })
    let myStyle = {
        color : props.mode === 'dark'?'white':'black',
        backgroundColor : props.mode === 'dark'?'rgb(34 66 104)':'white'
    }
    // const [btntext, setBtnText] = useState("Enable Dark Mode")

    // const toggleStyle = ()=>{
    //     if(myStyle.color ==='white')
    //     {
    //         setMyStyle({
    //             color:'black',
    //             backgroundColor:'white'
    //         })
    //         setBtnText("Enable Dark Mode")
    //     }
    //     else
    //     {
    //         setMyStyle({
    //             color : 'white',
    //             backgroundColor : 'black',
    //             border : '1px solid white'
    //         })
    //         setBtnText("Enable Light Mode")
    //     }
    // }
    return (
        <div className="container">
            <h2 className='mx-3' style={{color : props.mode === 'dark'?'white':'black',}}>About Us</h2>
            <div className="accordion" id="accordionExample">
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={myStyle}>
                            Analyze Your Text
                        </button>
                    </h2>
                    <div id="collapseOne"  className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body" >
                        <strong>Text Analysis Made Simple : </strong> This section allows you to easily analyze your text, providing insights at a glance. By default, this panel is open, showcasing its contents. The accordion component uses CSS transitions for smooth toggling between visible and hidden states. You can further customize this section with your own CSS to fit your design needs. 
                        {/* <code>.accordion-body</code> */}
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={myStyle}>
                            Free to Use
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        <strong>No Cost, Full Access : </strong> This section highlights that the tool is completely free to use. The content here is hidden by default, allowing users to expand it only if they want more information. The accordion's structure is designed for flexibility, supporting a wide range of HTML content within its body. 
                        {/* <code>.accordion-body</code> */}
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header" id="headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={myStyle}>
                            Browser Compatible
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        <strong>Cross-Browser Functionality : </strong> Ensure that your content is accessible across all major browsers. This section underscores the compatibility of your accordion component with different web environments. Like the other sections, it remains collapsed until the user chooses to expand it, offering a seamless user experience.
                         {/* <code>.accordion-body</code> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="container">
                <button className="btn btn-primary my-2" onClick={toggleStyle}>{btntext}</button>
            </div> */}
        </div>
    )
}
